import { memo } from 'react';
import { motion } from 'motion/react';
import { useGetParams } from '../../hooks/useGetParams';
import styles from './Advt.module.css';

import logo from '../../assets/images/logo.png';
import { MadeIactivePro } from '../MadeIactivePro/MadeIactivePro';

const Advt = memo(() => {
  const { title, qrCode1, qrCode2, paddingQR, sizeQR, titleFontSize } =
    useGetParams();

  return (
    <div className={styles.wrapper}>
      <motion.img
        initial={{ y: '-100%' }}
        animate={{ y: 0 }}
        transition={{ duration: 1 }}
        src={logo}
        alt="logo"
        className={styles.logo}
      />

      {title && (
        <div className={styles.wrapperTitleBlock}>
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 1 }}
            className={styles.titleBlock}
          >
            <div className={styles.leftTop} />

            <motion.div
              className={styles.alhimiya}
              style={{ fontSize: `${titleFontSize}rem` }}
            >
              {title}
            </motion.div>

            <div className={styles.rightTop} />
            <div className={styles.rightBottom} />
            <div className={styles.leftBottom} />
          </motion.div>
        </div>
      )}

      <div className={styles.qrsWrapper}>
        {qrCode1 && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 1, 0.03, 1] }}
            transition={{
              opacity: {
                duration: 1.5,
                delay: 1,
                times: [0, 0.33, 0.66, 1],
                ease: ['easeOut', 'easeOut', 'easeOut'],
              },
            }}
            className={styles.qrCode}
            style={{
              padding: `${paddingQR}rem`,
              background: paddingQR === '0' && 'none',
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode1} alt="qrCode1" />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 1, 0.03, 1] }}
            transition={{
              opacity: {
                duration: 1.5,
                delay: 1,
                times: [0, 0.33, 0.66, 1],
                ease: ['easeOut', 'easeOut', 'easeOut'],
              },
            }}
            className={styles.qrCode}
            style={{
              padding: `${paddingQR}rem`,
              background: paddingQR === '0' && 'none',
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode2} alt="qrCode2" />
          </motion.div>
        )}
      </div>

      <MadeIactivePro />
    </div>
  );
});

export default Advt;
